import { motion, useReducedMotion } from "framer-motion";
import { Reveal } from "./Reveal";
import { Surface } from "./Surface";

/* Только то, что уже правда. Одна широкая панель, внутри четыре пункта с галочками,
   которые прорисовываются при появлении. */
const RISKS = [
  ["Ничего не подписываешь", "Отправка формы не создаёт договора и никаких обязательств ни для тебя, ни для меня."],
  [
    "Созвон только по желанию",
    "Разбор приходит письменно в течение 2 рабочих дней. Созвон будет, только если ты сам захочешь после него.",
  ],
  ["Скажу прямо, если не моё", "Задача не под меня или хватит обычной автоматизации без ИИ: так и напишу и объясню почему."],
  [
    "Цена ошибки маленькая",
    "Начинаю с узкого MVP, метрику согласуем заранее. Если проект не работает, скажу об этом и деньги тянуть не буду.",
  ],
];

const Tick = ({ delay, reduce }) => (
  <span className="grid h-10 w-10 shrink-0 place-items-center rounded-full border border-accent/60 bg-accent/10 shadow-ring">
    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" aria-hidden="true">
      <motion.path
        d="M5 12.5l4.5 4.5L19 7.5"
        stroke="#9cc8ff"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
        initial={{ pathLength: reduce ? 1 : 0 }}
        whileInView={{ pathLength: 1 }}
        viewport={{ once: true, margin: "-64px" }}
        transition={{ duration: 0.7, delay: 0.3 + delay, ease: [0.22, 1, 0.36, 1] }}
      />
    </svg>
  </span>
);

export const Risks = () => {
  const reduce = useReducedMotion();
  return (
    <Reveal>
      <Surface className="grid md:grid-cols-2">
        {RISKS.map(([title, text], i) => (
          <div
            key={title}
            className={`flex gap-5 p-6 sm:p-8 ${i % 2 === 1 ? "md:border-l md:border-ink-4" : ""} ${
              i > 1 ? "border-t border-ink-4" : ""
            } ${i === 1 ? "border-t border-ink-4 md:border-t-0" : ""}`}
          >
            <Tick delay={i * 0.12} reduce={reduce} />
            <div>
              <h3 className="h3">{title}</h3>
              <p className="mt-2 text-base text-muted">{text}</p>
            </div>
          </div>
        ))}
      </Surface>
    </Reveal>
  );
};
